import { ActionType, } from 'typesafe-actions';

import * as actions from './actions';

export const FETCH_ME_REQUEST = 'FETCH_ME_REQUEST';
export const FETCH_ME_SUCCEEDED = 'FETCH_ME_SUCCEEDED';
export const FETCH_ME_FAILED = 'FETCH_ME_FAILED';
export const UPDATE_ME_CARTS = 'UPDATE_ME';
export type MeAction = ActionType<typeof actions>;

export type MeErrorType = {
    reason?: string,
};
